import { Component, Input } from '@angular/core';
import { Cms } from '@impact/data';

export type SectionHeaderAlignment = 'left' | 'center' | 'right';

@Component({
    selector: 'app-section-header',
    template: `
        <ng-container [ngSwitch]="isCentered" *ngIf="headerTextPrimary">
            <!-- Center aligned section header -->
            <header class="section-header--centered" *ngSwitchCase="true">
                <div class="component-header--small" *ngIf="headerCategoryText">
                    {{ headerCategoryText }}
                </div>
                <ng-container [ngSwitch]="headerSize">
                    <h1 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="1">{{ headerTextPrimary }}</h1>
                    <h2 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="2">{{ headerTextPrimary }}</h2>
                    <h3 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="3">{{ headerTextPrimary }}</h3>
                </ng-container>
                <h3 class="section-header__text--secondary" *ngIf="headerTextSecondary">
                    {{ headerTextSecondary }}
                </h3>
            </header>

            <!-- Left aligned section header -->
            <header class="section-header" *ngSwitchCase="false">
                <ng-container [ngSwitch]="headerCategoryText !== undefined && headerCategoryText !== ''">
                    <div *ngSwitchCase="true">
                        <div class="component-header--small">
                            {{ headerCategoryText }}
                        </div>
                        <ng-container [ngSwitch]="headerSize">
                            <h1 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="1">{{ headerTextPrimary }}</h1>
                            <h2 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="2">{{ headerTextPrimary }}</h2>
                            <h3 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="3">{{ headerTextPrimary }}</h3>
                        </ng-container>
                    </div>
                    <ng-container *ngSwitchCase="false" [ngSwitch]="headerSize">
                        <h1 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="1">{{ headerTextPrimary }}</h1>
                        <h2 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="2">{{ headerTextPrimary }}</h2>
                        <h3 [appColonSplit]="headerTextPrimary" class="section-header__text" *ngSwitchCase="3">{{ headerTextPrimary }}</h3>
                    </ng-container>
                </ng-container>

                <a
                    *ngIf="buttonLink?.url"
                    class="button--primary section-header__button button--themed"
                    [routerLink]="buttonLink?.cleanUrl"
                    [queryParams]="buttonLink?.urlParams"
                >
                    <ng-container [ngSwitch]="buttonLinkText !== ''">
                        <ng-container *ngSwitchCase="true">{{ buttonLinkText }}</ng-container>
                        <ng-container *ngSwitchCase="false">{{ buttonLink?.name }}</ng-container>
                    </ng-container>
                </a>
                <a *ngIf="buttonUrl && buttonLinkText" class="button--primary section-header__button button--themed" [routerLink]="buttonUrl">
                    {{ buttonLinkText }}
                </a>
            </header>

            <p *ngIf="introText" class="section-header__intro-text">
                {{ introText }}
            </p>

            <ng-content></ng-content>
        </ng-container>
    `,
})
export class SectionHeaderComponent {
    @Input() headerCategoryText?: string;
    @Input() headerTextPrimary: string | undefined;
    @Input() headerTextSecondary?: string | undefined;
    @Input() introText?: string;
    @Input() buttonLink?: Cms.Link;
    @Input() buttonUrl?: string;
    @Input() buttonLinkText?: string = ''; // Overrule the link text
    @Input() headerSize?: number = 3;
    @Input() isCentered?: boolean = false;
    @Input() variable?: string;
    @Input() appColonSplit: string;
}